var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStatusWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF9A33",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.861 5.706c.103.061.19.147.25.25l7.078 11.972c.2.338.087.774-.25.973-.11.065-.235.099-.362.099H5.423c-.393 0-.71-.318-.71-.71 0-.127.033-.252.098-.362L11.89 5.956c.2-.337.635-.45.972-.25zM12.5 15.872c-.307 0-.555.245-.555.547 0 .302.248.548.555.548.306 0 .555-.246.555-.548 0-.302-.249-.547-.555-.547zm.2-5.475h-.4c-.196 0-.355.159-.355.355v3.67c0 .196.16.355.355.355h.4c.196 0 .355-.16.355-.355v-3.67c0-.196-.16-.355-.355-.355z",
    transform: "translate(-321 -194) translate(165 147) translate(156 47)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusWarning);
export default __webpack_public_path__ + "static/media/icon-status-warning.35368e79ddfd5dabca1eab8fb36b1088.svg";
export { ForwardRef as ReactComponent };